import { partnerConstants } from './../constants/partner.constants'

const initialState = {
	loading: false,
	partnerPoints: null,
	partnerPointsWasLoaded: false
}

export default function partnerReducer(state = initialState, action) {
	switch (action.type) {
		case partnerConstants.LOADING_POINTS:
			return { ...state, partnerPointsWasLoaded: false }

		case partnerConstants.POINTS_WAS_LOADED:
			return { ...state, partnerPointsWasLoaded: true }

		case partnerConstants.GET_BALANCE_POINTS:
			return { ...state, partnerPoints: action.payload }

		default:
			return state
	}
}
